export default __webpack_public_path__ + "static/media/s2.43d0d16b.png";